// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import contactDeclarationEntity from './entities/contact-declaration.json';
import contactDeclarationMenu from '../pages/contact-declaration/menu.json';
import contactDeclarationFullForm from '../pages/contact-declaration/forms/full.json';
import contactDeclarationContextForm from '../pages/contact-declaration/forms/context.json';
import contactDeclarationMiniForm from '../pages/contact-declaration/forms/mini.json';
import contactDeclarationLookupForm from '../pages/contact-declaration/forms/lookup.json';
import contactDeclarationTableView from '../pages/contact-declaration/views/table.json';
import contactDeclarationCardsView from '../pages/contact-declaration/views/cards.json';
import contactDeclarationDashboardView from '../pages/contact-declaration/views/dashboard.json';

/** Тип запису «Декларація» зі сторінками пакета: меню, форми та подання з pages/contact-declaration/. */
export const contactDeclarationDefinition: IRecordTypeDefinition = {
  ...contactDeclarationEntity,
  views: assembleViewSet({
      table: contactDeclarationTableView,
      cards: contactDeclarationCardsView,
      dashboard: contactDeclarationDashboardView,
  }),
  form: contactDeclarationFullForm,
  forms: { full: contactDeclarationFullForm, context: contactDeclarationContextForm, mini: contactDeclarationMiniForm, lookup: contactDeclarationLookupForm },
  menu: contactDeclarationMenu,
} as IRecordTypeDefinition;
